import React from 'react';
import RatingBox from '../Rating/RatingBox';
import Modal from "./Modal";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCalendarAlt, faExternalLink} from "@fortawesome/free-solid-svg-icons";
import {getUtilisateurRoleIcon} from "../../services/UserService";
import TitleSecondary from "../Title/TitleSecondary";
import {login} from "../../services/AuthService";
import {useUser} from "../../contexts/UserContext";
import {useModal} from "../../contexts/ModalContext";
import {setSeanceShowLast} from "../../services/SeanceService";
import Routing from "../../services/routing";
import DateService from "../../services/DateService";

const ModalRating = ({ rate, seance, onSaveRating, onClose }) => {
    const { user } = useUser();
    const { showModal, hideModal } = useModal();

    const handleSuccess = (children = "") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    const disableLastSeanceModal = async () => {
        try {
            const response = await setSeanceShowLast(user.lastSeance.seanceId);
            if (!response.success) {
                handleError("Une erreur est survenue");
            }
            hideModal();
        } catch (error) {
            console.error('error', error);
        }
    }

    /* Mettre dans utils */
    const isVowel = (char) => {
        return ['a', 'e', 'i', 'o', 'u', 'y'].includes(char.toLowerCase());
    };
    const gestionVoyelle = (name) => {
        return isVowel(name.charAt(0)) ? "d'" : "de ";
    }

    return (
        <Modal onClose={onClose}>
            <div className="modal_content" style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "16px" }}>
                {/* <TitleSecondary text={`Donnez nous votre avis sur votre séance de ${seance.name}`} /> */}
                <h3 style={{ color: "var(--clr-main)", textAlign: "center", margin: "16px", display: "flex", flexWrap: "wrap" }}>
                    Donnez nous votre avis sur votre séance de { gestionVoyelle(seance.name) }{seance.name}
                </h3>

                <div style={{ display: "flex", flexDirection: "column", gap: "6px"}}>
                    <p>
                        <FontAwesomeIcon icon={faCalendarAlt}  style={{marginRight: '8px'}}/>
                        <span>{seance.date ? DateService.formatDateFull(seance.date) : "Date non trouvée"}</span>
                    </p>

                    <p>{getUtilisateurRoleIcon("ROLE_COACH")} <span  style={{marginLeft: '6px'}}>{seance.coach}</span></p>

                    <p>
                        <Link to={Routing.generate({route: Routing.routes.seance, params: { id: seance.seanceId }})} onClick={onClose}>
                            <FontAwesomeIcon icon={faExternalLink} style={{marginRight: '8px'}}/>
                            Voir la séance
                        </Link>
                    </p>
                </div>

                <RatingBox
                    label=""
                    count={5}
                    value={rate}
                    onChange={(newRate) => onSaveRating(newRate, seance.seanceId)}
                    color={"#ffffff"}
                    hoverColor={"#f1c40f"}
                    filledColor={"#cacaca"}
                />
                <button className="disableLastSeanceModal" onClick={disableLastSeanceModal}>Ne plus afficher</button>
            </div>
        </Modal>
    );
};

export default ModalRating;
